import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-columns">
          {/* Column 1 */}
          <div className="footer-col">
            <h4>Hispanic Women's Association of South Australia</h4>
          </div>

          {/* Column 2 */}
          <div className="footer-col">
            <ul className="contact-info">
              <li>MCCSA - 113 Gilbert Street</li>
              <li>Adelaide, South Australia, 5000</li>
              <li>Australia</li>
              <li>Tel: 0491 090 991</li>
              <li>Email: hwasa.adelaide@gmail.com</li>
              <li>Abierto todos los Viernes 10am - 2pm</li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footer-col">
            <ul className="footer-links">
              <li><Link to="/contáctanos">Contáctanos</Link></li>
              <li><Link to="/">Política de privacidad</Link></li>
              <li>
                <Link
                  className="social-icon-link facebook"
                  to={{ pathname: "https://www.facebook.com/HWAofSA" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  ¡Síguenos en Facebook! <i className="fab fa-facebook" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <hr />

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Hispanic Women's Association of South Australia</p>
          <p>
            Web Design by{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/angelarojasbotina/"
            >
              Angela R
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;